import { 
  SET_USER,
  SET_ROOMS,
} from './actions';

const DEFAULT_STATE = {
  user: '',
  rooms: [],
};

const setUser = (state, action) => Object.assign({}, state, { user: action.payload });
const setRooms = (state, action) => Object.assign({}, state, { rooms: action.payload });

const rootReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_USER:
      return setUser(state, action);
    case SET_ROOMS:
      return setRooms(state, action);
    default:
      return state;
  }
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers.js